(function () {

    "use strict";

    function applicationRun() {
    }

    applicationRun.$inject = [];

    angular.module("sphforms.app")
        .run(applicationRun);

}());
